const fares = {
  toast: {
    error: {
      badResponse: '[דמי נסיעה] תגובת שרת שגויה',
      create: {},
      edit: {},
    },
    success: {
      create: {
        default: '[דמי נסיעה] נוצר בהצלחה',
      },
      edit: {},
      delete: {
        default: '[דמי נסיעה] נמחק בהצלחה',
      },
    },
  },
  createFareBtn: 'הוסף',
  showBreakdownBtn: 'הצג פירוט',
  total: 'Total: ',

  deleteModal: {
    header: 'מחק דמי נסיעה',
    body: 'אתה עומד למחוק {{num}} תעריפים.',
  },

  table: {
    headers: {
      biDir: 'דו-כיווני',
    },
    biDirOptions: {
      way2: 'דו-כיווני',
      way1: 'חד-כיווני',
    },
    actions: {
      delete: 'מחק',
      export: 'ייצא',
    },
  },

  fareTypeOptions: {
    Base: 'בסיס',
    Addition: 'תוספת',
    Percent: 'אחוז',
    Total: 'סה"כ',
  },

  additions: {
    value: 'ערך',
    valueType: 'סוג ערך',
    name: 'שם',
    hour1: 'שעת התחלה',
    hour2: 'שעת סיום',
    date1: 'תאריך התחלה',
    date2: 'תאריך סיום',
    cancel: 'בטל',
    addAddition: 'הוסף תוספת',
    priority: 'עדיפות',
    weekDays: 'ימי השבוע',
    newAddition: 'תוספת חדשה',
    price: 'מחיר',
    total: 'סה"כ',
    percent: 'אחוז',
    columnExist: 'הכותרת כבר קיימת',
  },

  create: {
    confirmButtonText: 'אשר',
    code: 'קוד',
    from: 'מ-',
    to: 'אל',
    service: 'שירותים',
    select: 'בחר',
    validations: {
      code: 'קוד נדרש',
    },

    successToast: {
      message: 'הצלחה! התעריף נוצר.',
    },
    errorToast: {
      message: 'אירעה שגיאה! לא ניתן ליצור תעריף',
    },
  },

  update: {
    code: 'קוד',
    from: 'מ-',
    to: 'אל',
    service: 'שירותים',
    price: 'מחיר',
    confirmButtonText: 'עדכן',
    successMsg: 'התעריף עודכן בהצלחה',

    successToast: {
      message: 'הצלחה! התעריף עודכן בהצלחה.',
    },
    errorToast: {
      message: 'אירעה שגיאה! לא ניתן לעדכן תעריף',
    },
  },

  validations: {
    code: {
      require: 'קוד נדרש',
    },
    from: {
      require: 'מאת נדרש',
    },
    to: {
      require: 'אל נדרש',
    },
    service: {
      require: 'שירות נדרש',
    },
    unit: {
      require: 'יחידה נדרשת',
    },
    rateType: {
      require: 'סוג תעריף נדרש',
    },
  },
  forms: {
    header: {
      createFare: {
        title: 'הוסף',
      },

      updateFare: {
        title: 'עדכן',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'שמור',
        update: 'שמור',
      },
    },

    information: {
      details: {
        header: 'פרטי תעריף',
        fields: {
          units: {
            name: 'אתרים',
          },
          name: {
            name: 'שם',
          },
          group: {
            name: 'קבץ',
          },
          services: {
            name: 'שירותים',
          },
          biDirectional: {
            name: 'כיווני',
          },
          from: {
            name: 'מאזור',
          },
          to: {
            name: 'לאזור',
          },
        },
      },
      mileage: {
        header: 'קילומטראז\'',
        fields: {
          distanceFrom: {
            name: 'מרחק מ-',
          },
          distanceTo: {
            name: 'מרחק עד',
          },
        },
      },
      conditions: {
        header: 'תנאים',
        fields: {
          startDate: {
            name: 'תאריך התחלה',
          },
          endDate: {
            name: 'תאריך סיום',
          },
          startHour: {
            name: 'שעת התחלה',
          },
          endHour: {
            name: 'שעת סיום',
          },
          weekDays: {
            name: 'ימי השבוע',
          },
          fromDate: {
            name: 'מתאריך',
          },
          toDate: {
            name: 'עד תאריך',
          },
        },
      },
    },
  },
};

export default fares;
